import { render } from "./FacilityDetails.vue?vue&type=template&id=e0734c2a&scoped=true"
import script from "./FacilityDetails.vue?vue&type=script&lang=js"
export * from "./FacilityDetails.vue?vue&type=script&lang=js"

import "./FacilityDetails.vue?vue&type=style&index=0&id=e0734c2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0734c2a"]])

export default __exports__